// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-392e6cfe] .v-overlay__content {\n  position: unset !important;\n}\n.unselectable[data-v-392e6cfe] {\n  -moz-user-select: -moz-none;\n  -webkit-user-select: none;\n\n  /*\n     Introduced in IE 10.\n     See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/\n   */\n  user-select: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
